import { module as m } from 'modujs';
import gsap from "gsap";

export default class extends m {
    constructor (m) {
        super(m);

        // EVENTS
        this.events = {
            click: {
                'accordion': 'toggleAccordion'
            }
        }
    }

    init () {
    }

    /**
     * TOGGLE ACCORDION
     */
    toggleAccordion (e) {
        const item = e.currentTarget.closest('li');
        const isOpen = item.classList.contains('opened');

        if (isOpen) {
            this.closeAccordion(item);
        } else {
            this.openAccordion(item);
        }
    }

    /**
     * OPEN ACCORDION
     */
    openAccordion (item) {
        item.classList.add('opened');
        const wrapper = item.querySelector('.text-wrapper');
        const inner = wrapper.querySelector('.inner');

        gsap.to(wrapper, {
            duration: 1,
            height: inner.offsetHeight,
            ease: 'power4.inOut',
            onComplete: () => {
                this.call('update', {}, 'Load');
            }
        });
    }

    /**
     * CLOSE ACCORDION
     */
    closeAccordion (item) {
        item.classList.remove('opened');
        const wrapper = item.querySelector('.text-wrapper');

        gsap.to(wrapper, {
            duration: 1,
            height: 0,
            ease: 'power4.inOut',
            onComplete: () => {
                this.call('update', {}, 'Load');
            }
        });
    }
}